import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useGroupState = () => React.useContext(Context)
export const useGroup = () => useGroupState()?.userGroup

const QUERY = gql`
  query UserGroup($id: ID) {
    userGroup(id: $id, filter: { includeDeleted: true }) {
      id
      name
    }
  }
`

const GroupLoader = ({ children }) => {
  const id = useModalData()
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: accountsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default GroupLoader
